import React, { useState } from "react";
import { Share, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import { trackingUrl } from "@/lib/publicUrl";

export { trackingUrl };

/** Copies the public customer tracking URL for an order. */
export default function ShareTrackingButton({ orderId, orderNumber, className = "", compact = false }) {
  const [copied, setCopied] = useState(false);
  const url = trackingUrl(orderId);

  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Customer tracking link copied");
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <button
      onClick={copy}
      title={url}
      data-testid={`share-tracking-${orderNumber || orderId}`}
      className={`inline-flex items-center gap-1.5 border border-zinc-200 hover:border-[#0047AB] hover:text-[#0047AB] px-3 py-1.5 text-xs font-medium transition-colors ${className}`}
    >
      {copied ? <Check size={14} weight="bold" /> : <Share size={14} />}
      {compact ? (copied ? "Copied" : "Share") : copied ? "Link copied" : "Share Customer tracking Link"}
    </button>
  );
}
